var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement, nothing } from 'lit';
import { property, query, state } from 'lit/decorators.js';
import styles from './sds-navigation-item.lit.scss';
import { sdsCustomElement } from '../../utilities/custom-components';
import { classMap } from 'lit/directives/class-map.js';
import { computePosition, flip, offset } from '@floating-ui/dom';
import { hidePopover, showPopover, supportsPopoverAPI } from '../../utilities/dom';
/**
 * `sds-navigation-item` represents an item within a navigation menu,
 * supporting features such as icons, informational text, selection state,
 * and hover effects.
 *
 * ### Attributes
 * - `item-title`: The title text for the navigation item.
 * - `icon`: The icon displayed alongside the navigation item title.
 * - `info`: Additional informational text for the navigation item.
 * - `toggle`: Controls toggleable behavior for sub-items or expanded content.
 * - `section`: Marks the item as a section header when true.
 * - `selected`: Indicates whether the item is selected.
 * - `sidebar`: Specifies the sidebar configuration associated with the navigation item.
 * - `hovered`: Indicates if the navigation item is hovered.
 *
 * @tag sds-navigation-item
 */
let SdsNavigationItem = (() => {
    var _SdsNavigationItem_itemTitle_accessor_storage, _SdsNavigationItem_icon_accessor_storage, _SdsNavigationItem_info_accessor_storage, _SdsNavigationItem_toggle_accessor_storage, _SdsNavigationItem_section_accessor_storage, _SdsNavigationItem_group_accessor_storage, _SdsNavigationItem_selected_accessor_storage, _SdsNavigationItem_sidebar_accessor_storage, _SdsNavigationItem_href_accessor_storage, _SdsNavigationItem_native_accessor_storage, _SdsNavigationItem_expandTrigger_accessor_storage, _SdsNavigationItem_static_accessor_storage, _SdsNavigationItem_hovered_accessor_storage, _SdsNavigationItem_container_accessor_storage, _SdsNavigationItem_announceMessage_accessor_storage, _SdsNavigationItem_popoverOpen_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-navigation-item')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _itemTitle_decorators;
    let _itemTitle_initializers = [];
    let _itemTitle_extraInitializers = [];
    let _icon_decorators;
    let _icon_initializers = [];
    let _icon_extraInitializers = [];
    let _info_decorators;
    let _info_initializers = [];
    let _info_extraInitializers = [];
    let _toggle_decorators;
    let _toggle_initializers = [];
    let _toggle_extraInitializers = [];
    let _section_decorators;
    let _section_initializers = [];
    let _section_extraInitializers = [];
    let _group_decorators;
    let _group_initializers = [];
    let _group_extraInitializers = [];
    let _selected_decorators;
    let _selected_initializers = [];
    let _selected_extraInitializers = [];
    let _sidebar_decorators;
    let _sidebar_initializers = [];
    let _sidebar_extraInitializers = [];
    let _href_decorators;
    let _href_initializers = [];
    let _href_extraInitializers = [];
    let _native_decorators;
    let _native_initializers = [];
    let _native_extraInitializers = [];
    let _expandTrigger_decorators;
    let _expandTrigger_initializers = [];
    let _expandTrigger_extraInitializers = [];
    let _static_decorators;
    let _static_initializers = [];
    let _static_extraInitializers = [];
    let _hovered_decorators;
    let _hovered_initializers = [];
    let _hovered_extraInitializers = [];
    let _container_decorators;
    let _container_initializers = [];
    let _container_extraInitializers = [];
    let _announceMessage_decorators;
    let _announceMessage_initializers = [];
    let _announceMessage_extraInitializers = [];
    let _popoverOpen_decorators;
    let _popoverOpen_initializers = [];
    let _popoverOpen_extraInitializers = [];
    var SdsNavigationItem = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsNavigationItem_itemTitle_accessor_storage.set(this, __runInitializers(this, _itemTitle_initializers, undefined));
            _SdsNavigationItem_icon_accessor_storage.set(this, (__runInitializers(this, _itemTitle_extraInitializers), __runInitializers(this, _icon_initializers, undefined)));
            _SdsNavigationItem_info_accessor_storage.set(this, (__runInitializers(this, _icon_extraInitializers), __runInitializers(this, _info_initializers, undefined)));
            _SdsNavigationItem_toggle_accessor_storage.set(this, (__runInitializers(this, _info_extraInitializers), __runInitializers(this, _toggle_initializers, void 0)));
            _SdsNavigationItem_section_accessor_storage.set(this, (__runInitializers(this, _toggle_extraInitializers), __runInitializers(this, _section_initializers, false)));
            _SdsNavigationItem_group_accessor_storage.set(this, (__runInitializers(this, _section_extraInitializers), __runInitializers(this, _group_initializers, false)));
            _SdsNavigationItem_selected_accessor_storage.set(this, (__runInitializers(this, _group_extraInitializers), __runInitializers(this, _selected_initializers, false)));
            this.handleFocusIn = (__runInitializers(this, _selected_extraInitializers), (event) => {
                // Check if focus is moving to a child navigation item
                const target = event.target;
                if (target && target !== this && target.tagName === 'SDS-NAVIGATION-ITEM') {
                    // If this item is collapsed and focus is moving to a child, expand it
                    if (this.toggle === 'collapsed' && this.children.length > 0) {
                        this.toggle = 'expanded';
                        // Force parent to recalculate height
                        const parent = this.parentElement;
                        if (parent instanceof SdsNavigationItem) {
                            parent.requestUpdate();
                        }
                    }
                }
            });
            _SdsNavigationItem_sidebar_accessor_storage.set(this, __runInitializers(this, _sidebar_initializers, void 0));
            _SdsNavigationItem_href_accessor_storage.set(this, (__runInitializers(this, _sidebar_extraInitializers), __runInitializers(this, _href_initializers, void 0)));
            _SdsNavigationItem_native_accessor_storage.set(this, (__runInitializers(this, _href_extraInitializers), __runInitializers(this, _native_initializers, false)));
            _SdsNavigationItem_expandTrigger_accessor_storage.set(this, (__runInitializers(this, _native_extraInitializers), __runInitializers(this, _expandTrigger_initializers, 'icon')));
            _SdsNavigationItem_static_accessor_storage.set(this, (__runInitializers(this, _expandTrigger_extraInitializers), __runInitializers(this, _static_initializers, false)));
            _SdsNavigationItem_hovered_accessor_storage.set(this, (__runInitializers(this, _static_extraInitializers), __runInitializers(this, _hovered_initializers, void 0)));
            _SdsNavigationItem_container_accessor_storage.set(this, (__runInitializers(this, _hovered_extraInitializers), __runInitializers(this, _container_initializers, void 0)));
            this.activeItem = (__runInitializers(this, _container_extraInitializers), null);
            _SdsNavigationItem_announceMessage_accessor_storage.set(this, __runInitializers(this, _announceMessage_initializers, ''));
            _SdsNavigationItem_popoverOpen_accessor_storage.set(this, (__runInitializers(this, _announceMessage_extraInitializers), __runInitializers(this, _popoverOpen_initializers, false)));
            this.timer = (__runInitializers(this, _popoverOpen_extraInitializers), null);
            this.handleStaticClick = (event) => {
                event.stopPropagation();
                event.preventDefault();
            };
            this.handleKeyDown = (event) => {
                // Handle ESC key to focus skip-to-content button
                if (event.key === 'Escape') {
                    event.preventDefault();
                    this.focusSkipToContent();
                    return;
                }
                // If expandTrigger is 'icon', don't handle keyboard events for expansion
                // Let the icon button handle its own events
                if (this.expandTrigger === 'icon') {
                    return;
                }
                // Handle Enter and Space keys for activation
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    this.handleActivation(event);
                }
            };
            this.handleActivation = (event) => {
                if (this.static) {
                    this.handleStaticClick(event);
                }
                else if (this.children.length > 0 && this.expandTrigger === 'item') {
                    // Only expand/collapse if expandTrigger is 'item' (not 'icon')
                    this.expandOrCollapse(event);
                }
                else {
                    this.handleNavigation(event);
                }
            };
            this.focusSkipToContent = () => {
                const skipToContent = document.querySelector('sds-skip-to-content[slot="skip-to-content"]');
                if (skipToContent && typeof skipToContent.focus === 'function') {
                    skipToContent.focus();
                }
            };
            this.handleNavigation = (event) => {
                event.stopPropagation();
                event.preventDefault();
                const clickEvent = new CustomEvent('click', {
                    bubbles: false,
                    cancelable: true,
                    detail: {
                        itemTitle: this.itemTitle,
                        href: this.href,
                    },
                });
                this.dispatchEvent(clickEvent);
            };
            this.handleMouseEnter = async (event) => {
                if (!this.shouldDisplayPopover()) {
                    return;
                }
                const reference = event.currentTarget;
                this.updateActiveItem(reference);
                this.setupPopoverEventListeners();
                this.resetPopoverPosition();
                showPopover(this.container);
                this.popoverOpen = true;
                const { x, y } = await this.calculatePopoverPosition(reference);
                this.applyPopoverPosition(x, y < 0 ? 0 : y);
                this.adjustPopoverIfOutOfBounds(x, y < 0 ? 0 : y);
                this.requestUpdate();
            };
            this.handleMouseLeave = () => {
                if (!this.group) {
                    return;
                }
                this.timer = setTimeout(() => {
                    if (this.container && !this.container.matches(':hover')) {
                        this.hideCurrentPopover();
                    }
                }, 50);
            };
            this.handlePopoverMouseEnter = () => {
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
            };
            this.handlePopoverMouseLeave = () => {
                this.timer = setTimeout(() => {
                    var _a;
                    if (this.container &&
                        !this.container.matches(':hover') &&
                        !((_a = this.activeItem) === null || _a === void 0 ? void 0 : _a.matches(':hover'))) {
                        this.hideCurrentPopover();
                    }
                }, 100);
            };
            this.expandOrCollapse = (event) => {
                event.stopPropagation();
                event.preventDefault();
                if (this.toggle) {
                    const wasExpanded = this.toggle === 'expanded';
                    this.toggle = this.toggle === 'expanded' ? 'collapsed' : 'expanded';
                    // Announce the state change to screen readers
                    this.announceStateChange(wasExpanded);
                    // Force parent to recalculate height when this item's toggle changes
                    const parent = this.parentElement;
                    if (parent instanceof SdsNavigationItem) {
                        parent.requestUpdate();
                    }
                }
            };
        }
        /**
         * The title text displayed for this navigation item.
         * Useful for labeling or identifying the navigation item.
         *
         * Defaults to `undefined`.
         *
         * @attr {string} item-title - The title for the navigation item.
         */
        get itemTitle() { return __classPrivateFieldGet(this, _SdsNavigationItem_itemTitle_accessor_storage, "f"); }
        set itemTitle(value) { __classPrivateFieldSet(this, _SdsNavigationItem_itemTitle_accessor_storage, value, "f"); }
        /**
         * The icon displayed alongside the title of this navigation item.
         * This can enhance visual guidance for the navigation item.
         *
         * Defaults to `undefined`.
         *
         * @attr {string} icon - The icon for the navigation item.
         */
        get icon() { return __classPrivateFieldGet(this, _SdsNavigationItem_icon_accessor_storage, "f"); }
        set icon(value) { __classPrivateFieldSet(this, _SdsNavigationItem_icon_accessor_storage, value, "f"); }
        /**
         * Additional informational text for this navigation item.
         * This text can provide supplementary details or context.
         *
         * Defaults to `undefined`.
         *
         * @attr {string} info - Informational text for the navigation item.
         */
        get info() { return __classPrivateFieldGet(this, _SdsNavigationItem_info_accessor_storage, "f"); }
        set info(value) { __classPrivateFieldSet(this, _SdsNavigationItem_info_accessor_storage, value, "f"); }
        /**
         * Controls the toggleable behavior for the navigation item.
         * This is typically used to expand or collapse sub-items.
         *
         * @attr {string} toggle - Toggle behavior control.
         */
        get toggle() { return __classPrivateFieldGet(this, _SdsNavigationItem_toggle_accessor_storage, "f"); }
        set toggle(value) { __classPrivateFieldSet(this, _SdsNavigationItem_toggle_accessor_storage, value, "f"); }
        /**
         * Marks the item as a section header when true.
         * Section headers organize groups of related navigation items.
         *
         * Defaults to `false`.
         *
         * @attr {boolean} section - Indicates if the item is a section header.
         */
        get section() { return __classPrivateFieldGet(this, _SdsNavigationItem_section_accessor_storage, "f"); }
        set section(value) { __classPrivateFieldSet(this, _SdsNavigationItem_section_accessor_storage, value, "f"); }
        /**
         * Marks the item as a group header when true.
         * Group headers organize items of related navigation items.
         *
         * Defaults to `false`.
         *
         * @attr {boolean} group - Indicates if the item is a group header.
         */
        get group() { return __classPrivateFieldGet(this, _SdsNavigationItem_group_accessor_storage, "f"); }
        set group(value) { __classPrivateFieldSet(this, _SdsNavigationItem_group_accessor_storage, value, "f"); }
        /**
         * Indicates whether the navigation item is selected.
         * This can be used to highlight or indicate the active item.
         *
         * Defaults to `false`.
         *
         * @attr {boolean} selected - If true, the item is selected.
         */
        get selected() { return __classPrivateFieldGet(this, _SdsNavigationItem_selected_accessor_storage, "f"); }
        set selected(value) { __classPrivateFieldSet(this, _SdsNavigationItem_selected_accessor_storage, value, "f"); }
        connectedCallback() {
            super.connectedCallback();
            // Try to inherit expandTrigger from parent navigation component
            this.inheritExpandTriggerFromParent();
            // Add focus listener to detect when hidden children receive focus
            this.addEventListener('focusin', this.handleFocusIn);
        }
        disconnectedCallback() {
            super.disconnectedCallback();
            this.removeEventListener('focusin', this.handleFocusIn);
        }
        updated(changedProperties) {
            super.updated(changedProperties);
            // When hidden state changes (due to search), update all parent heights
            if (changedProperties.has('hidden')) {
                this.updateParentHeights();
            }
            // If expandTrigger is still 'icon' (default) but we have a parent, try to inherit
            if (this.expandTrigger === 'icon' && this.parentElement) {
                this.inheritExpandTriggerFromParent();
            }
            if (changedProperties.has('itemTitle')) {
                this.dispatchEvent(new CustomEvent(SdsNavigationItem.NAVIGATION_ITEM_CHANGED_EVENT, {
                    bubbles: false,
                    composed: true,
                }));
            }
        }
        inheritExpandTriggerFromParent() {
            // Find the parent navigation component
            let parent = this.parentElement;
            while (parent && parent.tagName !== 'SDS-NAVIGATION') {
                parent = parent.parentElement;
            }
            if (parent && parent.tagName === 'SDS-NAVIGATION') {
                // Check the attribute first, then try to access the property
                const parentExpandTrigger = parent.getAttribute('expand-trigger') || (parent === null || parent === void 0 ? void 0 : parent.expandTrigger);
                // Only update if the parent has a different value to avoid unnecessary re-renders
                // This handles timing issues where items are created before parent properties are set
                if (parentExpandTrigger && parentExpandTrigger !== this.expandTrigger) {
                    this.expandTrigger = parentExpandTrigger;
                    this.requestUpdate();
                }
            }
        }
        updateParentHeights() {
            // Update all parent navigation items to recalculate heights
            let currentParent = this.parentElement;
            while (currentParent instanceof SdsNavigationItem) {
                currentParent.requestUpdate();
                currentParent = currentParent.parentElement;
            }
        }
        /**
         * Specifies the sidebar configuration associated with this navigation item.
         *
         * @attr {string} sidebar - Sidebar configuration for the navigation item.
         */
        get sidebar() { return __classPrivateFieldGet(this, _SdsNavigationItem_sidebar_accessor_storage, "f"); }
        set sidebar(value) { __classPrivateFieldSet(this, _SdsNavigationItem_sidebar_accessor_storage, value, "f"); }
        /**
         * Defines the hyperlink reference for the navigation item.
         * When set, the item becomes a clickable link.
         *
         * @attr {string} href - The URL the navigation item should point to.
         */
        get href() { return __classPrivateFieldGet(this, _SdsNavigationItem_href_accessor_storage, "f"); }
        set href(value) { __classPrivateFieldSet(this, _SdsNavigationItem_href_accessor_storage, value, "f"); }
        /**
         * Enables native browser navigation when `href` is set.
         * If true, clicking the item will navigate using the browser's default behavior.
         * If false, custom event-based navigation can be implemented instead.
         *
         * Defaults to `false`.
         *
         * @attr {boolean} native - Enables native browser navigation.
         */
        get native() { return __classPrivateFieldGet(this, _SdsNavigationItem_native_accessor_storage, "f"); }
        set native(value) { __classPrivateFieldSet(this, _SdsNavigationItem_native_accessor_storage, value, "f"); }
        /**
         * Determines the trigger for expanding/collapsing navigation items with children.
         * When set to 'item', clicking anywhere on the item will expand/collapse it.
         * When set to 'icon', only clicking the expand/collapse icon will trigger the action.
         *
         * @attribute expand-trigger
         */
        get expandTrigger() { return __classPrivateFieldGet(this, _SdsNavigationItem_expandTrigger_accessor_storage, "f"); }
        set expandTrigger(value) { __classPrivateFieldSet(this, _SdsNavigationItem_expandTrigger_accessor_storage, value, "f"); }
        /**
         * Marks the item as static, meaning it is non-clickable and does not trigger any navigation or events.
         *
         * Defaults to `false`.
         *
         * @attr {boolean} static - Disables interactivity for the navigation item.
         */
        get static() { return __classPrivateFieldGet(this, _SdsNavigationItem_static_accessor_storage, "f"); }
        set static(value) { __classPrivateFieldSet(this, _SdsNavigationItem_static_accessor_storage, value, "f"); }
        /**
         * Indicates whether the navigation item is in a hovered state.
         * This can be used to style the item during hover interactions.
         *
         * Defaults to `false`.
         *
         * @attr {boolean} hovered - If true, the item is hovered.
         */
        get hovered() { return __classPrivateFieldGet(this, _SdsNavigationItem_hovered_accessor_storage, "f"); }
        set hovered(value) { __classPrivateFieldSet(this, _SdsNavigationItem_hovered_accessor_storage, value, "f"); }
        get container() { return __classPrivateFieldGet(this, _SdsNavigationItem_container_accessor_storage, "f"); }
        set container(value) { __classPrivateFieldSet(this, _SdsNavigationItem_container_accessor_storage, value, "f"); }
        /**
         * Message to announce via live region
         * @private
         */
        get announceMessage() { return __classPrivateFieldGet(this, _SdsNavigationItem_announceMessage_accessor_storage, "f"); }
        set announceMessage(value) { __classPrivateFieldSet(this, _SdsNavigationItem_announceMessage_accessor_storage, value, "f"); }
        get popoverOpen() { return __classPrivateFieldGet(this, _SdsNavigationItem_popoverOpen_accessor_storage, "f"); }
        set popoverOpen(value) { __classPrivateFieldSet(this, _SdsNavigationItem_popoverOpen_accessor_storage, value, "f"); }
        get navigationChildren() {
            return Array.from(this.children).filter((child) => child instanceof SdsNavigationItem);
        }
        get contentHeight() {
            const children = this.navigationChildren;
            if (children.length === 0) {
                return 0;
            }
            let totalHeight = 0;
            // Recursively calculate height of all visible children
            for (const child of children) {
                // Skip hidden items (they don't contribute to height)
                if (child.hidden) {
                    continue;
                }
                const childHeight = 48;
                totalHeight += childHeight;
                if (child.toggle === 'expanded') {
                    const childContentHeight = child.contentHeight;
                    totalHeight += childContentHeight;
                }
            }
            return totalHeight;
        }
        render() {
            return html `
            <div class="${this.getClasses()}">
                ${this.renderItemHeader()} ${this.renderItemContent()}
                ${this.renderStateAnnouncer()}
            </div>
            ${!this.group || this.sidebar !== 'folded' ? nothing : this.renderPopover()}
        `;
        }
        renderPopover() {
            var _a;
            const children = Array.from((_a = this.children) !== null && _a !== void 0 ? _a : []);
            const supportsPopover = supportsPopoverAPI();
            return html `
            <div popover="${supportsPopover ? 'manual' : nothing}" class="sds-navigation-popover">
                ${this.renderPopoverContent(this, this.static || this.expandTrigger === 'item'
                ? 'sds-navigation-popover__heading sds-navigation-popover__heading-static'
                : 'sds-navigation-popover__heading')}
                ${children.length
                ? html `<div class="sds-navigation-popover__content">
                          ${children.map((item) => this.renderPopoverContent(item, 'sds-navigation-popover__item'))}
                      </div>`
                : nothing}
            </div>
        `;
        }
        renderPopoverContent(item, className) {
            if (item.static || (item.children.length > 0 && item.expandTrigger === 'item')) {
                return html ` <div class="${className}">${item.itemTitle}</div>`;
            }
            if (item.href && !item.native) {
                return html `<a
                .href="${item.href}"
                @click="${item.handleNavigation}"
                class="${className} ${item.selected
                    ? 'sds-navigation-popover__item--selected'
                    : ''}"
                aria-label="${item.getAriaLabel()}"
                >${item.itemTitle}</a
            >`;
            }
            if (item.href && item.native) {
                return html `<a
                .href="${item.href}"
                class="${className} ${item.selected
                    ? 'sds-navigation-popover__item--selected'
                    : ''}"
                aria-label="${item.getAriaLabel()}"
                >${item.itemTitle}</a
            >`;
            }
            return html ` <div
            class="${className} ${item.selected ? 'sds-navigation-popover__item--selected' : ''}"
            @click="${item.handleNavigation}"
            aria-label="${item.getAriaLabel()}"
        >
            ${item.itemTitle}
        </div>`;
        }
        renderItemHeader() {
            if (this.static) {
                return html `${this.renderItemWithoutNavigation()}`;
            }
            if (this.children.length > 0 && this.expandTrigger === 'item') {
                return html `${this.renderItemWithExpandTrigger()}`;
            }
            if (this.href && !this.native) {
                return html `${this.renderItemCustomNavigationWithLink()}`;
            }
            if (this.href && this.native) {
                return html `${this.renderItemNativeNavigation()}`;
            }
            return html `${this.renderItemWithCustomNavigation()}`;
        }
        renderItemWithoutNavigation() {
            return html `
            <div
                tabindex="0"
                @click="${this.handleStaticClick}"
                @mouseenter="${this.handleMouseEnter}"
                @mouseleave="${this.handleMouseLeave}"
                @keydown="${this.handleKeyDown}"
                class="${classMap(this.getItemHeaderClasses())}"
                aria-label="${this.getAriaLabel()}"
            >
                ${this.renderItemIcon()} ${this.renderItemTitle()} ${this.renderHeaderArrowIcon()}
            </div>
        `;
        }
        renderItemWithExpandTrigger() {
            return html ` <div
            tabindex="0"
            @click="${this.expandOrCollapse}"
            @mouseenter="${this.handleMouseEnter}"
            @mouseleave="${this.handleMouseLeave}"
            @keydown="${this.handleKeyDown}"
            class="${classMap(this.getItemHeaderClasses())}"
            aria-expanded="${this.children.length > 0
                ? this.toggle === 'expanded'
                    ? 'true'
                    : 'false'
                : undefined}"
            aria-haspopup="${this.children.length > 0 ? 'true' : undefined}"
            aria-label="${this.getAriaLabel()}"
        >
            ${this.renderItemIcon()} ${this.renderItemTitle()} ${this.renderHeaderArrowIcon()}
        </div>`;
        }
        renderItemWithCustomNavigation() {
            return html ` <div
            tabindex="0"
            @click="${this.handleNavigation}"
            @mouseenter="${this.handleMouseEnter}"
            @mouseleave="${this.handleMouseLeave}"
            @keydown="${this.handleKeyDown}"
            class="${classMap(this.getItemHeaderClasses())}"
            aria-label="${this.getAriaLabel()}"
        >
            ${this.renderItemIcon()} ${this.renderItemTitle()} ${this.renderHeaderArrowIcon()}
        </div>`;
        }
        renderItemCustomNavigationWithLink() {
            return html ` <div
            @click="${this.handleNavigation}"
            @mouseenter="${this.handleMouseEnter}"
            @mouseleave="${this.handleMouseLeave}"
            @keydown="${this.handleKeyDown}"
            class="${classMap(this.getItemHeaderClasses())} sds-navigation-item__link-section"
            tabindex="-1"
        >
            <a
                href="${this.href}"
                class="sds-navigation-item__link"
                aria-label="${this.getAriaLabel()}"
                >${this.renderItemIcon()}${this.renderItemTitle()}</a
            >
            ${this.renderHeaderArrowIcon()}
        </div>`;
        }
        renderItemNativeNavigation() {
            return html ` <div
            @mouseenter="${this.handleMouseEnter}"
            @mouseleave="${this.handleMouseLeave}"
            @keydown="${this.handleKeyDown}"
            class="${classMap(this.getItemHeaderClasses())} sds-navigation-item__link-section"
            tabindex="-1"
        >
            <a
                href="${this.href}"
                class="sds-navigation-item__link"
                aria-label="${this.getAriaLabel()}"
                >${this.renderItemIcon()} ${this.renderItemTitle()}</a
            >
            ${this.renderHeaderArrowIcon()}
        </div>`;
        }
        getItemHeaderClasses() {
            return {
                'sds-navigation-item__header': true,
                'sds-navigation-item__header-static': this.static,
                'sds-navigation-item__header-section': this.section,
                'sds-navigation-item__header--hovered': this.popoverOpen,
            };
        }
        shouldDisplayPopover() {
            return this.group && this.sidebar === 'folded';
        }
        updateActiveItem(reference) {
            if (this.activeItem && this.activeItem !== reference) {
                this.hideCurrentPopover();
            }
            this.activeItem = reference;
        }
        setupPopoverEventListeners() {
            this.container.addEventListener('mouseleave', this.handlePopoverMouseLeave);
            this.container.addEventListener('mouseenter', this.handlePopoverMouseEnter);
        }
        resetPopoverPosition() {
            this.container.style.transform = 'translate(0px, 0px)';
        }
        async calculatePopoverPosition(reference) {
            const placement = this.isRightToLeft() ? 'left-start' : 'right-start';
            return computePosition(reference, this.container, {
                placement,
                middleware: [flip(), offset(4)],
            });
        }
        applyPopoverPosition(x, y) {
            const isRTL = this.isRightToLeft();
            const translateX = isRTL
                ? -(document.body.offsetWidth - x - this.container.offsetWidth)
                : x;
            this.container.style.transform = `translate(${translateX}px, ${y}px)`;
        }
        adjustPopoverIfOutOfBounds(x, y) {
            const popoverRect = this.container.getBoundingClientRect();
            const overflowY = popoverRect.top + this.container.offsetHeight - document.body.offsetHeight;
            if (overflowY > 0) {
                const adjustedY = y - overflowY;
                this.applyPopoverPosition(x, adjustedY);
            }
        }
        isRightToLeft() {
            return document.documentElement.getAttribute('dir') === 'rtl';
        }
        hideCurrentPopover() {
            if (this.container) {
                const content = this.container.querySelector('.sds-navigation-popover__content');
                if (content) {
                    content.scrollTo(0, 0);
                }
                hidePopover(this.container);
                this.popoverOpen = false;
                this.requestUpdate();
            }
            this.activeItem = null;
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
        }
        renderItemContent() {
            const height = this.contentHeight;
            // Always render content but control visibility with CSS classes
            return html `
            <div
                class="${classMap({
                'sds-navigation-item__content': true,
                'sds-navigation-item__content--expanded': this.toggle === 'expanded',
                'sds-navigation-item__content--collapsed': this.toggle === 'collapsed',
            })}"
                part="sds-navigation-item-content"
                style="--content-height: ${height}px;"
            >
                <slot></slot>
            </div>
        `;
        }
        renderHeaderArrowIcon() {
            var _a;
            if (((_a = this === null || this === void 0 ? void 0 : this.children) === null || _a === void 0 ? void 0 : _a.length) > 0 &&
                (this.toggle === 'expanded' || this.toggle === 'collapsed')) {
                if (this.expandTrigger === 'icon') {
                    // When expandTrigger is 'icon', use a clickable button
                    return html `
                    <sds-button
                        class="sds-navigation-item__arrow-icon"
                        type="ghost"
                        size="md"
                        icon="${this.toggle === 'collapsed'
                        ? 'arrow_down_small'
                        : 'arrow_up_small'}"
                        @click="${this.expandOrCollapse}"
                    >
                    </sds-button>
                `;
                }
                // When expandTrigger is 'item', use a visual icon only
                return html `
                <sds-icon
                    class="sds-navigation-item__arrow-icon sds-navigation-item__arrow-only-icon"
                    size="16"
                    name="${this.toggle === 'collapsed' ? 'arrow_down_small' : 'arrow_up_small'}"
                >
                </sds-icon>
            `;
            }
        }
        renderItemTitle() {
            return html `
            <sds-clipped-text
                part="sds-navigation-item-title"
                basic
                text="${this.itemTitle}"
            ></sds-clipped-text>
        `;
        }
        renderItemIcon() {
            if (this.icon !== '' && this.icon !== undefined) {
                return html `
                <sds-icon
                    class="sds-navigation-item__icon"
                    size="24"
                    name="${this.icon}"
                ></sds-icon>
            `;
            }
        }
        getAriaLabel() {
            const itemName = this.itemTitle || 'navigation item';
            const labelParts = [itemName];
            // Add selected state
            if (this.selected) {
                labelParts.push('current page');
            }
            // Add expandable/collapsible state for items with children
            if (this.children.length > 0 && this.toggle) {
                const state = this.toggle === 'expanded' ? 'expanded' : 'collapsed';
                labelParts.push(state);
            }
            return labelParts.join(', ');
        }
        renderStateAnnouncer() {
            // Only render the live region when there's actually a message to announce
            if (this.announceMessage) {
                return html `
                <div class="sr-only" aria-live="polite" aria-atomic="true">
                    ${this.announceMessage}
                </div>
            `;
            }
            return nothing;
        }
        announceStateChange(wasExpanded) {
            const itemName = this.itemTitle || 'navigation item';
            const newState = wasExpanded ? 'collapsed' : 'expanded';
            const message = `${itemName} ${newState}`;
            // Set the message to create the live region and announce it
            this.announceMessage = message;
            // Remove the live region after announcement (also cleans up DOM)
            setTimeout(() => {
                this.announceMessage = '';
            }, 1000);
        }
        hasSelectedDescendant(element) {
            return Array.from(element.children).some(child => {
                const navItem = child;
                return navItem.selected || this.hasSelectedDescendant(child);
            });
        }
        getClasses() {
            return classMap({
                'sds-navigation-item': true,
                'sds-navigation-item--hovered': this.hovered,
                'sds-navigation-item--selected': this.selected,
                'sds-navigation-item--section': this.section,
                'sds-navigation-item--folded': this.sidebar === 'folded',
                'sds-navigation-item--has-arrow-button': this.toggle,
                'sds-navigation-item--expanded': !this.section && this.toggle === 'expanded' && this.sidebar !== 'folded',
            });
        }
        click() {
            const syntheticEvent = new MouseEvent('click', {
                bubbles: false,
                cancelable: false,
                view: window,
            });
            if (this.static) {
                this.handleStaticClick(syntheticEvent);
            }
            else if (this.children.length > 0 && this.expandTrigger === 'item') {
                this.expandOrCollapse(syntheticEvent);
            }
            else if (this.href && !this.native) {
                this.handleNavigation(syntheticEvent);
            }
        }
    };
    _SdsNavigationItem_itemTitle_accessor_storage = new WeakMap();
    _SdsNavigationItem_icon_accessor_storage = new WeakMap();
    _SdsNavigationItem_info_accessor_storage = new WeakMap();
    _SdsNavigationItem_toggle_accessor_storage = new WeakMap();
    _SdsNavigationItem_section_accessor_storage = new WeakMap();
    _SdsNavigationItem_group_accessor_storage = new WeakMap();
    _SdsNavigationItem_selected_accessor_storage = new WeakMap();
    _SdsNavigationItem_sidebar_accessor_storage = new WeakMap();
    _SdsNavigationItem_href_accessor_storage = new WeakMap();
    _SdsNavigationItem_native_accessor_storage = new WeakMap();
    _SdsNavigationItem_expandTrigger_accessor_storage = new WeakMap();
    _SdsNavigationItem_static_accessor_storage = new WeakMap();
    _SdsNavigationItem_hovered_accessor_storage = new WeakMap();
    _SdsNavigationItem_container_accessor_storage = new WeakMap();
    _SdsNavigationItem_announceMessage_accessor_storage = new WeakMap();
    _SdsNavigationItem_popoverOpen_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsNavigationItem");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _itemTitle_decorators = [property({ type: String, attribute: 'item-title' })];
        _icon_decorators = [property({ type: String })];
        _info_decorators = [property({ type: String })];
        _toggle_decorators = [property({ type: String, reflect: true })];
        _section_decorators = [property({ type: Boolean })];
        _group_decorators = [property({ type: Boolean })];
        _selected_decorators = [property({ type: Boolean, reflect: true })];
        _sidebar_decorators = [property({ type: String, reflect: true })];
        _href_decorators = [property({ type: String })];
        _native_decorators = [property({ type: Boolean })];
        _expandTrigger_decorators = [property({ type: String })];
        _static_decorators = [property({ type: Boolean })];
        _hovered_decorators = [property({ type: Boolean, reflect: true })];
        _container_decorators = [query('div.sds-navigation-popover')];
        _announceMessage_decorators = [state()];
        _popoverOpen_decorators = [state()];
        __esDecorate(_classThis, null, _itemTitle_decorators, { kind: "accessor", name: "itemTitle", static: false, private: false, access: { has: obj => "itemTitle" in obj, get: obj => obj.itemTitle, set: (obj, value) => { obj.itemTitle = value; } }, metadata: _metadata }, _itemTitle_initializers, _itemTitle_extraInitializers);
        __esDecorate(_classThis, null, _icon_decorators, { kind: "accessor", name: "icon", static: false, private: false, access: { has: obj => "icon" in obj, get: obj => obj.icon, set: (obj, value) => { obj.icon = value; } }, metadata: _metadata }, _icon_initializers, _icon_extraInitializers);
        __esDecorate(_classThis, null, _info_decorators, { kind: "accessor", name: "info", static: false, private: false, access: { has: obj => "info" in obj, get: obj => obj.info, set: (obj, value) => { obj.info = value; } }, metadata: _metadata }, _info_initializers, _info_extraInitializers);
        __esDecorate(_classThis, null, _toggle_decorators, { kind: "accessor", name: "toggle", static: false, private: false, access: { has: obj => "toggle" in obj, get: obj => obj.toggle, set: (obj, value) => { obj.toggle = value; } }, metadata: _metadata }, _toggle_initializers, _toggle_extraInitializers);
        __esDecorate(_classThis, null, _section_decorators, { kind: "accessor", name: "section", static: false, private: false, access: { has: obj => "section" in obj, get: obj => obj.section, set: (obj, value) => { obj.section = value; } }, metadata: _metadata }, _section_initializers, _section_extraInitializers);
        __esDecorate(_classThis, null, _group_decorators, { kind: "accessor", name: "group", static: false, private: false, access: { has: obj => "group" in obj, get: obj => obj.group, set: (obj, value) => { obj.group = value; } }, metadata: _metadata }, _group_initializers, _group_extraInitializers);
        __esDecorate(_classThis, null, _selected_decorators, { kind: "accessor", name: "selected", static: false, private: false, access: { has: obj => "selected" in obj, get: obj => obj.selected, set: (obj, value) => { obj.selected = value; } }, metadata: _metadata }, _selected_initializers, _selected_extraInitializers);
        __esDecorate(_classThis, null, _sidebar_decorators, { kind: "accessor", name: "sidebar", static: false, private: false, access: { has: obj => "sidebar" in obj, get: obj => obj.sidebar, set: (obj, value) => { obj.sidebar = value; } }, metadata: _metadata }, _sidebar_initializers, _sidebar_extraInitializers);
        __esDecorate(_classThis, null, _href_decorators, { kind: "accessor", name: "href", static: false, private: false, access: { has: obj => "href" in obj, get: obj => obj.href, set: (obj, value) => { obj.href = value; } }, metadata: _metadata }, _href_initializers, _href_extraInitializers);
        __esDecorate(_classThis, null, _native_decorators, { kind: "accessor", name: "native", static: false, private: false, access: { has: obj => "native" in obj, get: obj => obj.native, set: (obj, value) => { obj.native = value; } }, metadata: _metadata }, _native_initializers, _native_extraInitializers);
        __esDecorate(_classThis, null, _expandTrigger_decorators, { kind: "accessor", name: "expandTrigger", static: false, private: false, access: { has: obj => "expandTrigger" in obj, get: obj => obj.expandTrigger, set: (obj, value) => { obj.expandTrigger = value; } }, metadata: _metadata }, _expandTrigger_initializers, _expandTrigger_extraInitializers);
        __esDecorate(_classThis, null, _static_decorators, { kind: "accessor", name: "static", static: false, private: false, access: { has: obj => "static" in obj, get: obj => obj.static, set: (obj, value) => { obj.static = value; } }, metadata: _metadata }, _static_initializers, _static_extraInitializers);
        __esDecorate(_classThis, null, _hovered_decorators, { kind: "accessor", name: "hovered", static: false, private: false, access: { has: obj => "hovered" in obj, get: obj => obj.hovered, set: (obj, value) => { obj.hovered = value; } }, metadata: _metadata }, _hovered_initializers, _hovered_extraInitializers);
        __esDecorate(_classThis, null, _container_decorators, { kind: "accessor", name: "container", static: false, private: false, access: { has: obj => "container" in obj, get: obj => obj.container, set: (obj, value) => { obj.container = value; } }, metadata: _metadata }, _container_initializers, _container_extraInitializers);
        __esDecorate(_classThis, null, _announceMessage_decorators, { kind: "accessor", name: "announceMessage", static: false, private: false, access: { has: obj => "announceMessage" in obj, get: obj => obj.announceMessage, set: (obj, value) => { obj.announceMessage = value; } }, metadata: _metadata }, _announceMessage_initializers, _announceMessage_extraInitializers);
        __esDecorate(_classThis, null, _popoverOpen_decorators, { kind: "accessor", name: "popoverOpen", static: false, private: false, access: { has: obj => "popoverOpen" in obj, get: obj => obj.popoverOpen, set: (obj, value) => { obj.popoverOpen = value; } }, metadata: _metadata }, _popoverOpen_initializers, _popoverOpen_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsNavigationItem = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    _classThis.NAVIGATION_ITEM_CHANGED_EVENT = 'sds.nav.item.change';
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsNavigationItem = _classThis;
})();
export { SdsNavigationItem };
